export const stringify = passengers => {
  const qs =
    passengers
      .map(
        (p, index) =>
          (p.frequentTravellerDiscount && p.frequentTravellerDiscount.selected
            ? `P${index + 1}`
            : undefined)
      )
      .filter(index => index)
      .join('') || undefined
  return qs
}

export const parse = key => {
  if (key) {
    var passengers = []

    var passengerIndexes = key.substring(1).split('P')

    passengerIndexes.forEach(i => {
      passengers[Number(i) - 1] = {selected: true}
    })

    return passengers
  } else {
    return []
  }
}
